import fp from 'lodash/fp';
import createReducer from '../../../helpers/createReducer';
import {
  createFetchManyHandler,
  createSaveHandler,
  createUpdateHandler,
  createDeleteHandler
} from '../../../helpers/reducerRoutineCrudHandler';
import {
  onDeletedReportTemplate,
  resetDeleteReportTemplate
} from '../../actions/report-template';
import {
  fetchReportTemplates,
  createReportTemplate,
  updateReportTemplate,
  deleteReportTemplate
} from '../../sagas/report-template/routines';

const initialState = {
  all: {},
  fetching: false,
  fetched: false,
  fetchingError: null,
  saving: false,
  saved: false,
  savingError: null,
  deleting: false,
  deleted: false,
  deletingError: null
};

const createOnDeletedHandler = action => ({
  [action.toString()]: (state, { payload }) => ({
    ...state,
    deleted: true,
    all: fp.omit(payload.id, state.all)
  })
});

const createResetDeleteHandler = action => ({
  [action.toString()]: fp.set('deleted', false)
});

export default createReducer(initialState, {
  ...createFetchManyHandler(fetchReportTemplates),
  ...createSaveHandler(createReportTemplate),
  ...createUpdateHandler(updateReportTemplate),
  ...createDeleteHandler(deleteReportTemplate),
  ...createOnDeletedHandler(onDeletedReportTemplate),
  ...createResetDeleteHandler(resetDeleteReportTemplate)
});
